import styled from 'styled-components';
import fonts from '../../../helpers/fonts';
import spacing from '../../../helpers/spacing';

export const CardGridContainer = styled.div<{ hasCta: boolean }>`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ hasCta }) => (hasCta ? spacing(6) : 0)};
`;

export const Heading = styled.h2`
  ${fonts.headingMedium};
  margin-bottom: ${spacing(2)};
`;

export const Subheading = styled.p`
  ${fonts.paragraphLarge}
  margin-bottom: ${spacing(2)};
`;

export const CtaWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
